// v1.1.2 - Fixed API endpoints with /v1 prefix
import { apiClient } from './client';
import { unwrapAndTransform } from '../utils/api-response';
// ---------------------------------------------------------------------------
// All unwrapping now handled by unwrapAndTransform
// Eliminates: manual response.data.data || response.data fallback patterns
// Note: Custom field transformations (startTime, endTime, workflowName) are
// now handled automatically by snake_case to camelCase conversion
// ---------------------------------------------------------------------------
export const schedulerApi = {
    // Get scheduler status (includes config, stats, and eligible users count)
    getStatus: async () => {
        const response = await apiClient.get('/v1/admin/scheduler/status');
        return unwrapAndTransform(response);
    },
    // Get scheduler configuration (extracted from status)
    getConfig: async () => {
        const response = await apiClient.get('/v1/admin/scheduler/status');
        const status = unwrapAndTransform(response);
        return status.config;
    },
    // Get scheduler statistics (extracted from status)
    getStats: async () => {
        const response = await apiClient.get('/v1/admin/scheduler/status');
        const status = unwrapAndTransform(response);
        return status.stats;
    },
    // Get eligible users (returns empty array - count is in stats)
    getEligibleUsers: async () => {
        // Backend doesn't return full user list, only count in stats
        // Return empty array for now
        return [];
    },
    // Trigger scheduler manually
    trigger: async () => {
        await apiClient.post('/v1/admin/scheduler/trigger');
    },
    // Pause scheduler
    pause: async () => {
        await apiClient.post('/v1/admin/scheduler/pause');
    },
    // Resume scheduler
    resume: async () => {
        await apiClient.post('/v1/admin/scheduler/resume');
    },
    // List workflow runs
    listWorkflowRuns: async (params) => {
        const response = await apiClient.get('/v1/admin/scheduler/workflow-runs', { params });
        return unwrapAndTransform(response);
    },
    // Get workflow run details
    getWorkflowRun: async (id) => {
        const response = await apiClient.get(`/v1/admin/scheduler/workflow-runs/${id}`);
        return unwrapAndTransform(response);
    },
    // Retry workflow run
    retryWorkflowRun: async (id) => {
        await apiClient.post(`/v1/admin/scheduler/workflow-runs/${id}/retry`);
    },
    // Cancel workflow run
    cancelWorkflowRun: async (id) => {
        await apiClient.post(`/v1/admin/scheduler/workflow-runs/${id}/cancel`);
    },
};
